export default {
    base: {
        inter: 'Internationalization',
        developing: 'Developing...',
    },
    home: {
        msg: 'Luck Draw',
        wisdom: 'Luck is the shadow of opportunity. -- Socrates',
        downTem: 'Download data template',
        lc: 'Luck Card',
        lw: 'Luck Wheel',
        lcl: 'Luck Cloud',
        ls: 'Luck Star',
        am: 'About Me',
        co: 'Contact',
        sup: 'Support',
        dev: 'Developer',
        sin: 'Sina:',
        eml: 'E-mail:',
        pay: 'Reward code',
        wechatPayTip: 'Please long press the QR code in WeChat'
    },
    list: {
        cell: {},
        clTitle: 'Are you sure clear this list?',
        clCache: 'Are you sure clear cache?',
        content: 'This operation is not recoverable！',
        okText: 'Yes',
        cancelText: 'No',
        ad: 'Add',
        cl: 'Clear',
        del: 'Delete',
        dela: 'Sure to delete?',
        col: '[{"title":"id","dataIndex":"key"},{"title":"name","dataIndex":"name","width":"20%"},{"title":"subtitle","dataIndex":"subtitle","width":"20%"},{"title":"url","dataIndex":"url","width":"30%"},{"title":"remark","dataIndex":"remark"},{"title":"operation","dataIndex":"operation","width":"100px","fixed":"right"}]'
    },
    luckCard: {
        header: {
            title: "Luck Card",
            subtitle: "This is a game",
            rr: "Random Refresh",
            cc: "Clear Cache",
            st: "Setting",
        },
        card: {
            remark: 'please input winner',
            winner: 'remarked',
            clear: 'cleared'
        },
        no: 'NO:',
        listTitle: 'Data Source Of Card:'
    },
    luckWheel: {
        header: {
            title: "Luck Wheel",
            subtitle: "This is a game",
            rr: "Random Refresh",
            cc: "Clear Cache",
            st: "Setting",
        },
        listTitle: 'Data Source Of Wheel:'
    },
    luckCloud: {
        header: {
            title: "Luck Cloud",
            subtitle: "This is a game",
            rr: "Random Refresh",
            cc: "Clear Cache",
            st: "Setting",
        },
        listTitle: 'Data Source Of Cloud:',
        selectedTitle: 'Selected Menu',
        selectedSubtitle: 'Ψ=Ψ（x，y，z，t）',
        placeholder: 'select count',
        switchTips: 'is allow repeated selection',
        allow: 'allow',
        ban: 'ban',
        go: 'Action',
        start: 'Start',
        stop: 'Stop'
    },
    luckStar: {
        header: {
            title: "Luck Star",
            subtitle: "This is a game",
            rr: "Random Refresh",
            cc: "Clear Cache",
            st: "Setting",
        },
        go: 'Go',
        start: 'Start',
        stop: 'Stop',
        noMore0: 'There\'s no option!',
        noMore1: 'There\'s only one option!',
        message: 'Notes',
        description: 'Options not enough, please click \'Setting\' button, add option.',
        emptyTip: 'please click \'Go\' button',
        listTitle: 'Data Source Of Star:'
    }
};
